import { render, staticRenderFns } from "./RowSection.vue?vue&type=template&id=2d0c995a&scoped=true&"
import script from "./RowSection.vue?vue&type=script&lang=js&"
export * from "./RowSection.vue?vue&type=script&lang=js&"
import style0 from "./RowSection.vue?vue&type=style&index=0&id=2d0c995a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c995a",
  null
  
)

export default component.exports